<script>
import VisualizacaoCadastro from './VisualizacaoCadastro.vue'
import axios from '@/utils/api'

export default {
  components: {
    VisualizacaoCadastro
  },
  props: {
    protocolo: {
      type: String
    },
    cadastroContainerCustomClasses: {
      type: [String, Array],
      required: false
    }
  },
  data () {
    return {
      loading: true,
      loadingTab: false,
      actualTab: 'CADASTRO',
      versaoCadastro: 1,
      cadastro: null,
      processo: null,
      historico: null,
      infosCadastro: null
    }
  },
  async created () {
    if (this.protocolo) {
      try {
        await this.getInfos()
        if (this.infosCadastro.versoes.length) {
          this.versaoCadastro = this.infosCadastro.versoes[this.infosCadastro.versoes.length - 1].id
          await this.getCadastro(this.versaoCadastro)
        }
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    async handleChangeTab (name) {
      if (name === 'CADASTRO' && !this.cadastro) {
        try {
          this.loadingTab = true
          await this.getCadastro(this.versaoCadastro)
        } finally {
          this.loadingTab = false
        }
      }
      if (name === 'PROCESSO' && !this.processo) {
        try {
          this.loadingTab = true
          await this.getDespachos(this.protocolo)
        } catch (e) {
          this.processo = []
        } finally {
          this.loadingTab = false
        }
      }
      if (name === 'HISTORICO' && (!this.historico || !this.historico.length)) {
        try {
          this.loadingTab = true
          await this.getHistorico(this.protocolo)
        } catch (e) {
          this.historico = []
        } finally {
          this.loadingTab = false
        }
      }
    },
    async handleChangeVersao (versao) {
      try {
        this.loadingTab = true
        await this.getCadastro(versao)
      } finally {
        this.loadingTab = false
      }
    },
    async getCadastro (versao = '1.0') {
      this.cadastro = await axios({
        method: 'GET',
        url: `cadastro/${this.protocolo}/${versao}`,
        loader: false
      })
    },
    async getInfos () {
      this.infosCadastro = await axios({
        method: 'GET',
        url: `cadastro/${this.protocolo}/view/infos`,
        loader: false
      })
    },
    async getDespachos (protocolo) {
      this.processo = await axios({
        method: 'GET',
        url: `despacho/view/resume/byProcesso/${protocolo}`,
        loader: false
      })
    },
    async getHistorico (protocolo) {
      this.historico = await axios({
        method: 'GET',
        url: `tramitacao/viewHistorico/byProcesso/${protocolo}`,
        loader: false
      })
    }
  }
}
</script>

<template>
    <VisualizacaoCadastro
    v-if="cadastro"
    :infosCadastro="{...infosCadastro, protocolo}"
    :loading="loading"
    :loadingTab="loadingTab"
    :actualTab.sync="actualTab"
    :showHeader="true"
    :versaoCadastro.sync="versaoCadastro"
    :cadastro="cadastro"
    :processo="processo"
    :historico="historico"
    @update:actualTab="handleChangeTab"
    @update:versaoCadastro="handleChangeVersao"
    :cadastroContainerCustomClasses="cadastroContainerCustomClasses"
    />
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/VisualizarCadastro.vue